import { Box, Paper, Typography, useTheme } from '@mui/material'
import React from 'react'
import { IClientFloors } from '../../all-types'
import { setSelectedTable } from '../../redux-store'
import { useAppDispatch, useAppSelector } from '../../redux-store/hooks'
import { BillCounterTable } from './bill-counter-table'

interface FloorViewerProps {
  selectedFloor: IClientFloors
}

export const FloorViewer: React.FC<FloorViewerProps> = ({ selectedFloor }) => {
  const theme = useTheme()
  const allPlaces = useAppSelector((state) => state.preloadData.places)
  const allTables = useAppSelector((state) => state.preloadData.tables)

  const dispatcher = useAppDispatch()

  if (!selectedFloor || !selectedFloor.floorMap) {
    return <Typography>No floor data available.</Typography>
  }

  const floorTables = allTables.filter((t) => t.floorId === selectedFloor._id)
  const floorPlaces = allPlaces.filter((p) => p.floorId === selectedFloor._id)

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        padding: 2,
        display: 'block',
        //backgroundColor: '#fafafa',
      }}
    >
      <Paper
        elevation={4}
        sx={{
          position: 'relative',
          minWidth: selectedFloor.floorMap.width,
          minHeight: selectedFloor.floorMap.height,
          backgroundImage: `url(${selectedFloor.floorMap.bgImage})`,
          backgroundSize: 'auto', // Maintain original size
          backgroundRepeat: 'repeat', // Repeat the image
          backgroundPosition: 'top left',
          //border: '2px solid #3f51b5',
          //borderRadius: '8px',
        }}
      >
        {/* Tables */}
        {floorTables.map((table) => (
          <Box
            key={table._id}
            onClick={() => dispatcher(setSelectedTable(table))}
            sx={{
              position: 'absolute',
              width: table.width,
              height: table.height,
              left: table.xAxis,
              top: table.yAxis,
              transform: `rotate(${table.rotation || 0}deg)`,
              zIndex: 20,
              cursor: 'pointer',
              //pointerEvents: 'none',
            }}
          >
            <BillCounterTable
              {...table}
              tableColor={
                table.billSession === null
                  ? theme.palette.freeTable.main
                  : theme.palette.occupiedTable.main
              }
            />
          </Box>
        ))}

        {/* Places */}
        {floorPlaces.map((place, index) => (
          <Box
            key={place._id || index}
            sx={{
              position: 'absolute',
              width: place.placeMap?.width || 100,
              height: place.placeMap?.height || 100,
              left: place.placeMap?.xAxis || 0,
              top: place.placeMap?.yAxis || 0,
              //border: '2px dashed #42a5f5',
              backgroundColor: place.placeMap?.bgcolor || 'rgba(4, 4, 4, 0.75)',
              //borderRadius: '8px',
              zIndex: 10,
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              pointerEvents: 'none',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 'bold',
                color: place.placeMap?.textColor || 'primary.dark',
              }}
            >
              {place.placeName}
            </Typography>
          </Box>
        ))}

        {/* Props */}
        {selectedFloor.floorMap.floorProps.map((prop, index) => (
          <Box
            key={`prop-${index}`}
            sx={{
              position: 'absolute',
              width: prop.width,
              height: prop.height,
              left: prop.xAxis,
              top: prop.yAxis,
              transform: `rotate(${prop.rotation || 0}deg)`,
              pointerEvents: 'none',
              zIndex: 30,
            }}
          >
            <img
              src={prop.propImage}
              alt={prop.propName}
              width="100%"
              height="100%"
              style={{
                borderRadius: 4,
                objectFit: 'contain',
              }}
            />
          </Box>
        ))}
      </Paper>
    </Box>
  )
}
